import { helper } from '@ember/component/helper';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

export default helper(function _sanitizeHtml([unsafe], { config }) {
  return sanitizeHtml(unsafe, { config });
});
